
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { SubscriptionPlanForm } from "@/components/admin/subscriptions/SubscriptionPlanForm";
import { useSubscriptions } from "@/hooks/useSubscriptions";
import { toast } from "sonner";

export default function SubscriptionPlanCreatePage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { useCreateSubscriptionPlanMutation } = useSubscriptions();
  const createPlan = useCreateSubscriptionPlanMutation();

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      const features = {
        currency_conversion: data.features?.currency_conversion || false,
        multiple_currencies: data.features?.multiple_currencies || false,
        price_comparison: data.features?.price_comparison || false,
        grouped_contracts: data.features?.grouped_contracts || false,
        contract_services: data.features?.contract_services || false,
        reminders: data.features?.reminders || false,
        payment_type_selection: data.features?.payment_type_selection || false,
        dashboard: data.features?.dashboard || false,
        contract_pdf_email: data.features?.contract_pdf_email || false
      };

      await createPlan.mutateAsync({
        ...data,
        features,
        show_on_landing: data.show_on_landing || false
      });
      
      toast.success("Subscription plan created successfully");
      navigate("/admin", { state: { from: "subscription-plans" } });
    } catch (error) {
      console.error("Failed to create plan:", error);
      toast.error("Failed to create subscription plan. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const handleCancel = () => {
    navigate("/admin", { state: { from: "subscription-plans" } });
  };

  return (
    <div className="container py-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/admin", { state: { from: "subscription-plans" } })}
          className="h-8 w-8"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-2xl font-bold">Create Subscription Plan</h1>
      </div>
      
      <div className="bg-card rounded-lg border shadow">
        <div className="p-6">
          <SubscriptionPlanForm 
            onSubmit={handleSubmit} 
            onCancel={handleCancel}
            plan={null}
          />
        </div>
      </div>
    </div>
  );
}
